import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { IframeAppEmbedderComponent } from "libraries/component/iframe-app-embedder/iframe-app-embedder.component";
import {
    IframeAppEmbedderAncillaryServicesPageComponent
} from "./iframe-app-embedder-ancillary-services-page.component";
import {
    IframeAppEmbedderAncillaryServicesSummaryComponent
} from "libraries/component/iframe-app-embedder/iframe-app-embedder-ancillary-services-summary.component";
import {
    IframeAppEmbedderAncillaryListComponent
} from "libraries/component/iframe-app-embedder/iframe-app-embedder-ancillary-list.component";


@NgModule({
    imports: [
        CommonModule,
    ],
    exports: [
        IframeAppEmbedderComponent,
        IframeAppEmbedderAncillaryServicesPageComponent,
        IframeAppEmbedderAncillaryServicesSummaryComponent,
        IframeAppEmbedderAncillaryListComponent,
    ],
    declarations: [
        IframeAppEmbedderComponent,
        IframeAppEmbedderAncillaryServicesPageComponent,
        IframeAppEmbedderAncillaryServicesSummaryComponent,
        IframeAppEmbedderAncillaryListComponent,
    ],
    providers: [],
})
export class IframeAppEmbedderModule {
}
